import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from './components/AuthProvider';
import { getAdAttribution } from './lib/adAttribution';
import { sendCAPIEvent, submitOnboarding } from './lib/api';
import { trackMetaCustomEvent, trackMetaEvent } from './lib/meta';
import posthog from './lib/posthog';
import './PostSignupPage.css';

const OPTIONS = [
  {
    value: 'marketing',
    label: 'Marketing',
    description: 'Ads, social content, or promotional videos for a brand or product.',
  },
  {
    value: 'personal',
    label: 'Personal',
    description: 'Creative projects, entertainment, or just exploring.',
  },
];

function PostSignupPage() {
  const navigate = useNavigate();
  const { user, loading } = useAuthContext();

  const [submittingValue, setSubmittingValue] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (loading) return;
    if (!user) navigate('/', { replace: true });
  }, [loading, user, navigate]);

  useEffect(() => {
    const eventId = trackMetaEvent('ViewContent', {
      content_type: 'post_signup_questionnaire',
      content_name: 'Post Signup Questionnaire',
    });
    sendCAPIEvent('ViewContent', eventId, {
      content_type: 'post_signup_questionnaire',
      content_name: 'Post Signup Questionnaire',
    }, getAdAttribution()).catch(() => {});
  }, []);

  const handleSelect = (value) => {
    if (submittingValue) return;
    setSubmittingValue(value);
    setError('');

    if (user?.id) {
      localStorage.setItem(`latted_post_signup_answered:${user.id}`, 'true');
      localStorage.removeItem(`latted_needs_post_signup:${user.id}`);
    }
    posthog.capture('post signup use type selected', { use_type: value });
    trackMetaCustomEvent('OnboardingIntentSelected', {
      use_type: value,
      onboarding_flow: value === 'marketing' ? 'marketing' : 'personal',
    });

    const targetPath = value === 'marketing' ? '/onboarding/marketing' : '/';
    navigate(targetPath, { replace: true });

    void submitOnboarding({ useType: value }).catch((e) => {
      console.error('Failed to persist post-signup use type:', e);
    });
  };

  return (
    <div className="post-signup-root">
      <div className="post-signup-card">
        <div className="post-signup-header">
          <h2 className="post-signup-title">How will you be using Latted?</h2>
          <p className="post-signup-subtitle">
            This helps us tailor your experience. You can change this later.
          </p>
        </div>

        <div className="post-signup-choices">
          {OPTIONS.map((opt) => (
            <button
              key={opt.value}
              type="button"
              className={`post-signup-choice${submittingValue === opt.value ? ' is-selected' : ''}`}
              onClick={() => handleSelect(opt.value)}
              disabled={!!submittingValue}
            >
              <span className="post-signup-choice-label">{opt.label}</span>
              <span className="post-signup-choice-desc">{opt.description}</span>
            </button>
          ))}
        </div>

        {error && <div className="post-signup-error">{error}</div>}
      </div>
    </div>
  );
}

export default PostSignupPage;
